import React, { useState, useEffect } from "react";
import Navbar from "../components/navbar/navbar.component";
import Footer from "../components/footer/footer.component";
import styles from "./../styles/whitepaper.scss";
import { Document, Page, pdfjs } from "react-pdf";
import doc from "../assets/CETOWhitepaper1.5.pdf";
import mascot from "../public/Group 4069.svg";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
// Material-UI
import { IconButton } from "@material-ui/core";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { ArrowBackIos } from "@material-ui/icons";
import GreenButton from "../components/cinema-draft-button/cinema-draft-button.component";
import Pagination from "@material-ui/lab/Pagination";

const Faq = () => {
  const converter = () => {
   
  
    var base58_addresses = [
      "",
      "",
      "THuh7w6FW3C645wA4NXNnzjiZr5NTD13xR",
      "TVw7W7T9s19qrAhMuuSnD36E5MQhUa9fe3",
      "TPqLsC6Qt9FLZeqJiW1U3j1Svo79G1he94",
      "TTYWmz3CA4hZ4gVx3oZpnscPTanwoA2YXB",
      "TBQaYFAjL6ZzQW199oG7Du8GcWtZmK5yPH",
      "TU1wh1BdRBX4jCaFxhccWfYRnVGvZnAzQd",
      "TBHwVr3jyGgT6mt95fVgDhQTyGCU5VDHnt",
      "TS6HLZFkeT1L9roqvhK6nWias5GmEAfuXk",
      "TP1KwBJyneHLHohj1Yv7hmMuS89Crk18X3",
      "TGXazroQCpeNmYVb7te9QktAjXgkLHbBgJ",
      "TCT4cCh9EJQ34Mk96v9CoVvUMfE2HEXTb2",
      "TCn6hk3NCXR8MSXj9hjQkXQ8ui872o1HmW",
      "TYrGB5VYXCkcjAo8frSXUMGMxePPcSmyeK",
      "TCkoZqKV21FpusCEj1SCUzyy9jPYoQRZ9z",
      "TALUg2N2tyFhqoXPsuEQjTL6hEk38AXznn",
      "TWVfDB68abooS7E63aEhFzojbU7yLFDkq6",
      "TJjvDKwWsS5yJuHhGef9hTXrbb4hExEZwG",
      "TPnCAURir32zH8GbafKvb14wrLmbkGPnaL",
      "TCkr6mbZ4jYJShVbyejbAGTaT4vg2x27o9",
      "TSLZFeWqCxKKmwL63u7Ns9nWWrfvNud1D7",
      "TMK9CSJmtyCZ79dRMxZAY11i1nHrVX1aKZ",
      "TB9sZFv1XCDnehbNm3mwCJ8MnCtrmTT31T",
      "TMvbgeZ3MeSd9ZmRuwhQnHrVpcAsw4RETH"


    ];
    var hex_addresses = [];
    var base58_addresses_check = []
    base58_addresses.forEach(element => {
      var hex = window.tronWeb.address.toHex(element);
      hex = "0x" + hex.slice(2, hex.length);
      hex_addresses.push(`ambassadors_[${hex}] = true;`);
    });
    console.log(hex_addresses )
    hex_addresses.forEach(element => {
      var base = window.tronWeb.address.fromHex(element);
      base58_addresses_check.push(base);
    });
    for(var i = 0 ; i < base58_addresses.length ; i++){
      if(base58_addresses_check[i] == base58_addresses[i]){
        // console.log("correctt")

      }
      else{
        // console.log(base58_addresses_check ,base58_addresses,i);

      }
    }
  }
  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }, []);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [page, setPage] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <>
      <Navbar page={4} />
      <div className="social__body">
        <div className="heads">
          <p className="th">Crystal Elephant Token (CETO)</p>
          <p className="ph">Whitepaper</p>
        </div>
        <div className="midinfo">
          <div className="motto l">
            <p>Strength.</p>
            <p>Wisdom.</p>
            <p>Loyalty.</p>
            <p>
              Be the <span>Elephant</span>{" "}
            </p>
            <p>in the Room.</p>
          </div>
          <div className="doc_container">
            <Document file={doc} onLoadSuccess={onDocumentLoadSuccess}>
              <Page pageNumber={pageNumber} />
            </Document>
            <p className="page_num">
              <div className="pagi">
                <Pagination
                  style={{ color: "#691AAA" }}
                  count={numPages}
                  pagep={pageNumber}
                  onChange={(e, page) => {
                    setPageNumber(page);
                  }}
                  color="primary"
                />
              </div>
            </p>
          </div>
          <div className="mascot l">
            <img
              src="https://res.cloudinary.com/dgdjabqwr/image/upload/v1610803016/cd3d/Group_5256_1_eihx0s.png"
              alt="elephant"
            />
          </div>
        </div>
        <GreenButton
          style={{ background: "#009EE4", color: "#ffffff", margin: "auto" }}
          onClick={() =>
            window.open(
              `${window.location.origin}/static/media/CETOWhitepaper1.5.30eb9382.pdf`
            )
          }
        >
          Download Whitepaper
        </GreenButton>
      </div>
      <Footer />
    </>
  );
};

export default Faq;
